import clsx from 'clsx';
import React from 'react';
import './UiTableCellCheckbox.css';
import { UiInput } from '../../input/UiInput';
export function UiTableCellCheckbox(_a) {
    var checked = _a.checked, onChange = _a.onChange;
    return (React.createElement("td", { className: clsx('UiTableCellCheckbox') },
        React.createElement(UiInput, { value: checked, onChangeValue: onChange, type: "checkbox" })));
}
